import Swiper from 'swiper/bundle';
import bulmaModal from "./bulmaModal";

export default function leafcourt() {
	const lc_swipers = () => {
		const typeA_nav = new Swiper(".lc_private_a_nav", {
			spaceBetween: 10,
			slidesPerView: 8,
			navigation: false
		});
		const typeA_main = new Swiper(".lc_private_a", {
			centeredSlides: true,
			slidesPerView: 1,
			thumbs: {
				swiper: typeA_nav,
			},
			autoplay: {
				delay: 2500,
				disableOnInteraction: true,
				pauseOnMouseEnter: true
			},
		});

		const typeB_nav = new Swiper(".lc_private_b_nav", {
			spaceBetween: 10,
			slidesPerView: 8,
			navigation: false
		});
		const typeB_main = new Swiper(".lc_private_b", {
			centeredSlides: true,
			slidesPerView: 1,
			thumbs: {
				swiper: typeB_nav,
			},
			autoplay: {
				delay: 2500,
				disableOnInteraction: true,
				pauseOnMouseEnter: true
			},
		});

		// const typeC_nav = new Swiper(".lc_private_c_nav", {
		// 	spaceBetween: 10,
		// 	slidesPerView: 8,
		// 	navigation: false
		// });
		// const typeC_main = new Swiper(".lc_private_c", {
		// 	centeredSlides: true,
		// 	slidesPerView: 1,
		// 	thumbs: {
		// 		swiper: typeC_nav,
		// 	},
		// 	autoplay: {
		// 		delay: 2500,
		// 		disableOnInteraction: true,
		// 		pauseOnMouseEnter: true
		// 	},
		// });

		const floor = new Swiper(".lc_private_floor", {
			centeredSlides: true,
			slidesPerView: 2.2,
			pagination: {
				el: "._floor-pager",
				bulletClass: "_bullet",
				bulletActiveClass: "_active",
				clickable: true,
				renderBullet: function (index, className) {
					return `<span class="${className}">${index + 1}F</span>`;
				},
			},
			autoplay: {
				delay: 2500,
				disableOnInteraction: true,
				pauseOnMouseEnter: true
			},
		});
	}
	const lc_daynight = () => {
		const day = document.querySelectorAll("._day");
		const night = document.querySelectorAll("._night");
		function swapDN(day, night) {
			if (typeof day === "object" && typeof night === "object") {
				day.forEach(function (e) {
					e.classList.toggle("_active");
				})
				night.forEach(function (e) {
					e.classList.toggle("_active");
				})
			}
		}
		setInterval(swapDN, 3000, day, night);
	}

	const loop = () => {
		const headerHeight = document.querySelector("[data-scroll-header]").clientHeight;
		const logo = document.getElementById("logo");
		if (logo!==null) {
			if (headerHeight <= window.scrollY) {
				logo.classList.add("_small");
			} else {
				logo.classList.remove("_small");
			}
		}
		window.requestAnimationFrame(loop);
	}
	loop();

	const init = () => {
		lc_swipers();
		lc_daynight();
		bulmaModal();
	}

	if (document.readyState !== "loading") {
		init();
	} else {
		document.addEventListener("DOMContentLoaded", () => {
			init();
		})
	}
}